import React from "react";

const defaultMaterialData = [
  {
    materialIssue: "",
    isOpportunity: false,
    reason: "",
    mitigationPlan: "",
    financialImpact: "",
  },
];

const MaterialIssuesTable = ({ materialTable, setMaterialTable }) => {
  const handleInputChange = (index, field, value) => {
    const updated = [...materialTable];
    updated[index][field] = value;
    setMaterialTable(updated);
  };

  const toggleRiskOpportunity = (index) => {
    const updated = [...materialTable];
    updated[index].isOpportunity = !updated[index].isOpportunity;
    setMaterialTable(updated);
  };

  const addRow = () => {
    setMaterialTable([
      ...materialTable,
      {
        materialIssue: "",
        isOpportunity: false,
        reason: "",
        mitigationPlan: "",
        financialImpact: "",
      },
    ]);
  };

  const removeRow = () => {
    if (materialTable.length > 1) {
      setMaterialTable(materialTable.slice(0, -1));
    }
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", color: "#000" }}>
              <th style={tableHeaderStyle}>S. No.</th>
              <th style={tableHeaderStyle}>Material Issue</th>
              <th style={tableHeaderStyle}>Risk or Opportunity</th>
              <th style={tableHeaderStyle}>Reason for Identification</th>
              <th style={tableHeaderStyle}>
                In case of risk, approach to adapt or mitigate
              </th>
              <th style={tableHeaderStyle}>
                Financial Impact (Positive/Negative)
              </th>
            </tr>
          </thead>
          <tbody>
            {materialTable.map((row, index) => (
              <tr key={index}>
                <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                  {index + 1}
                </td>

                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.materialIssue}
                    placeholder="Enter Material Issue"
                    onChange={(e) =>
                      handleInputChange(index, "materialIssue", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                <td style={tableCellStyle}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <span>Risk</span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={row.isOpportunity}
                        onChange={() => toggleRiskOpportunity(index)}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span>Opportunity</span>
                  </div>
                </td>

                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.reason}
                    placeholder="Enter the reason for identification"
                    onChange={(e) =>
                      handleInputChange(index, "reason", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.mitigationPlan}
                    placeholder="Enter Adaptation or mitigation Plan"
                    onChange={(e) =>
                      handleInputChange(index, "mitigationPlan", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.financialImpact}
                    placeholder="Enter Positive or Negative Financial Impacts"
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "financialImpact",
                        e.target.value
                      )
                    }
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        {materialTable.length > 1 && (
          <button onClick={removeRow} style={removeButtonStyle}>
            - Remove
          </button>
        )}
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>

      {/* Toggle CSS */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 44px;
          height: 22px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #8a4a68;
        }

        input:checked + .slider:before {
          transform: translateX(22px);
        }
      `}</style>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default MaterialIssuesTable;
